<template>
    <div class="wrap-content">
        <div class="content-login">
            <div class="brand">
                <img src="../assets/icon_cms/Logo.svg" class="logo-top" alt="kbi"/>
            </div>
            <div class="wrap-login">
                <div class="logo-title">
                    <h1>Login</h1>
                    <p>Clearinghouse Management System </p>
                    <p>Kliring Berjangka Indonesia</p>
                </div>
                <b-alert variant="danger" :show="statusLogin == 2023 || statusLogin == 2018">Username atau Password salah</b-alert>
                <b-alert variant="danger" :show="status == 404">Akun tidak terdaftar</b-alert>
                <form @submit.prevent="login">
                    <div class="form-group">
                        <span><i class="fa fa-user"></i></span>
                        <input type="text" class="input-file w-full" placeholder="username" v-model="form.username" />
                    </div>
                    <div class="form-group">
                        <span><i class="fa fa-lock"></i></span>
                        <input type="password" class="input-file w-full" placeholder="password" v-model="form.password" />
                    </div>
                    <button type="submit" class="button-primer w-full">
                        <span v-show="!isLoading">Login</span>
                        <Loader v-show="isLoading" />
                    </button>
                </form>
            </div>
        </div>
        <div class="wrap-organizer">
            <div class="wrap-img">
                <img src="../assets/icon_cms/logo-kemendag.svg" alt="footer"/>
                <img src="../assets/icon_cms/logo-kbi-white.svg" alt="footer"/>
                <img src="../assets/icon_cms/logo-danantara.svg" alt="footer"/>
                <div class="powered">
                    <p>Technology Provider</p>
                    <img src="../assets/icon_cms/logo-bei-white.svg" alt="bei" class="img-bei"/>
                </div>
            </div>
            <div class="title-powered">2025 @ CMS - KBI</div>
        </div>
    </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import sha256 from "sha256";
export default {
    components: {
        Loader,
    },
    data() {
        return {
            form: {
                username: "",
                password: "",
            },
            isLoading: false,
            status: "",
            scriptCaptcha: "",
        };
    },
    methods: {
        login() {
            this.isLoading = true;
            window.grecaptcha.enterprise.ready(async () => {
                const tokenCaptcha = await window.grecaptcha.enterprise.execute("6LcOUPckAAAAAHXPk2_ORUtBQK0u3aKSti-9UUSf", { action: "LOGINKLIRING" });
                let data = {
                    username: this.form.username,
                    password: sha256(this.form.password),
                    clientCaptchaKey: tokenCaptcha,
                };
                this.$store
                    .dispatch("LOGIN", data)
                    .then(() => {
                        const role = sessionStorage.getItem("role");
                        if (role == 1 || role == 2 || role == 4) {
                            window.location.href = "/";
                        } else if (role == 6) {
                            window.location.href = "/admin-pos";
                        } else if (role == 8) {
                            window.location.href = "/bappebti-inventory";
                        } else {
                            window.location.href = "/operator-deposite";
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            });
        },
    },
    computed: {
        statusLogin() {
            let status = this.$store.state.status_login;
            return status;
        },
    },
    created() {
        this.scriptCaptcha = document.createElement("script");

        // this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6LdkqcUkAAAAAGwOMHZdqguhNkd2ktVfiD7DDRkV"; // dev
        this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6LcOUPckAAAAAHXPk2_ORUtBQK0u3aKSti-9UUSf"; // prod
        this.scriptCaptcha.async = true;

        document.body.appendChild(this.scriptCaptcha);
    },
    beforeDestroy() {
        document.body.removeChild(this.scriptCaptcha);
    },
};
</script>

<style scoped>

.wrap-content {
    background: linear-gradient(180deg, #32B8FE 0%, #243A72 100% );
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0;
}

.content-login{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 35rem;
}

.wrap-login {
    background: var(--white);
    width: 100%;
    border-radius: 1.25rem;
    padding: 2rem;
}

.brand {
    margin-bottom: 3.75rem;
}

.logo-title{
    text-align: center;
    margin-bottom: 3rem;
    color: var(--astronout-950);
}

.logo-title h1{
    font-size: 2rem;
    margin-bottom: 0.5rem;
    font-weight: 800;
}

.logo-title p{
    margin: unset;
    font-size: 0.875rem;
}

.title {
    margin-bottom: 30px;
    font-size: 30px;
}

.form-group {
    position: relative;
    margin-bottom: 1rem;
}

.form-group span {
    position: absolute;
    border: inherit;
    text-align: center;
    padding: 7px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    top: 50%;
    left: 0.75rem;
    transform: translateY(-50%);
    color: #32B8FE;
}

.input-file{
    padding-left: 2.75rem;
}

.button-primer{
    margin-top: 1rem;
}

.wrap-organizer {
    margin-top: 3.75rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
}

.wrap-organizer .powered{
    color: #FFFFFFBF;
    font-size: 0.675rem;
    font-weight: 400;
    text-align: center;
}

.wrap-content .powered p{
    margin-bottom: 0.25rem;
    text-align: center;
}


.title-powered {
    color: #FFFFFFBF;
    margin-bottom: 0.75rem;
    font-size: 0.75rem;
    font-weight: normal;
}

.wrap-img {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}

@media only screen and (max-width: 600px) {
    .wrap-login {
        width: 87%;
    }
}
</style>
